module.exports = __webpack_public_path__ + "static/logo-1cbc4a2dad7143254d59a2c0649951fd.svg";